import React from 'react';
import { motion } from 'framer-motion';

const Badge = ({ children, icon, variant = 'success' }) => {
  const variants = {
    success: 'glass border border-violet-200 text-gray-700',
    info: 'bg-blue-50 text-blue-700 border border-blue-200',
    primary: 'glass-violet border border-violet-300 text-violet-700',
    secondary: 'glass border border-gray-200 text-gray-700',
    gradient: 'bg-gradient-to-r from-violet-600 to-pink-600 text-white border-0'
  };

  return (
    <motion.div
      className={`inline-flex items-center px-4 py-2 rounded-full shadow-md ${variants[variant]}`}
      whileHover={{ scale: 1.05, y: -2 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      {icon && <span className="font-bold mr-2">{icon}</span>}
      <span className="text-sm font-medium">{children}</span>
    </motion.div>
  );
};

export default Badge;
